<template>
  <div class="cart">  
    <h2>{{ $t('myCart') }}</h2>
    <ul class="cartList">
      <li v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines" :key="index">
        <div class="img">
          <img :src="item.Thumbnail" alt="">
        </div>
        <div class="min">
          <p>{{item.Name}}</p>
          <p class="money">${{item.UnitPrice.toFixed(2)}}</p>
        </div>
        <div class="plus">
          <span @click="updateItemCount($event, item)">-</span>
          <p>{{item.Quantity}}</p>
          <span @click="throttleAddToCart(item)">+</span>
        </div>
      </li>
    </ul>       
    <div class="cartbot">
      <div class="left">
        <span>{{ $t('subtotal') }}({{this.$store.state.cart.cartProductsList.TotalCount}} {{ $t('items') }})</span>
        <span>{{ $t('taxAndShipping') }}</span>
        <span class="money">${{calculateLocalSubtotal()}} </span>
      </div>
      <button @click="postCartItemsAndCheckout($event)" class="btn" >{{ $t('checkOut') }}</button>
    </div>  
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import _ from 'lodash';
import Router from '../router/index';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";

export default {
  name: "cart",
  data(){
    return{
      addressList: [],
      deliveryDate: undefined,
      deliveryTime: undefined,
      willCallLocation: undefined,
      warehouseList: [],
      billingAddressOpen: false,
      creditCardOpen: false,
      customerNote: '',
      orders: [],
      unpaidAmount: undefined,
      isBlocking: true,
      isCreditUsed: false,
      isLoadingWarehouseList: false,
      isLoadingAddressList: false,
      isLoadingSubmitOrder: false,
      pickUpTime: '',
      isAddressBookOpen: false,
      stepIndex: 0,
      width: 0,
      promoCode: '',
      validatedPromoCode: undefined,
      promoCodeIsValid: false,
      promoCodeMessage: '',
      isValidatingPromoCode: false,
      // selectedPaymentMethod: PAYMENT_OPTIONS.alipay,
      isCashAllowed: false,
      bypass: null,
      local: null,
    }
  },
  methods:  {
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('products', ['updateActiveProduct']),
    goToLogin() {
      this.$router.push('/login')
    },
    checkAuthentication(authCallback) {
      this.isAuthenticated = isUserAuthenticated(), authCallback;
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  updateItemCount(e, item) {
    e.preventDefault();
      if (isUserAuthenticated()) {
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
        this.deleteItem(item);
      } else {
        this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
        .then(() => {
          this.local = false;
          this.$store.dispatch('cart/getCart');
        });
      }
    } else {
      item.quantity = item.quantity - 1;
      if (item.quantity < 1) {
        this.deleteItem(item)
      }
      this.$store.dispatch('cart/updateLocalCart', item)
      .then(() => {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      })
    }
  },
  postCartItemsAndCheckout(e) {
    e.preventDefault();
    if (isUserAuthenticated()) {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      const isUSA = localStorage.getItem('isUSA');
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.$router.push('/purchase');
      });
    } else {
      this.$router.push('/login');
    }
  },
  localTotalPrice(price, quantity) {
    return (price * quantity).toFixed(2);
  },
  handleCartProductImageClick(productNum) {
    this.$router.history.push(`/productdetails?productnum=${productNum}`);
  },
  calculateLocalSubtotal() {
    if (this.local) {
      let cost = 0;
       this.$store.state.cart.cartProductsList.map(item => {
        let itemPrice = item.Price * item.quantity;
        cost += itemPrice; 
      })
      return cost.toFixed(2);
    } else {
      return this.$store.state.cart.cartProductsList.TotalPrice.toFixed(2);
    }
  },
  calculateTotalCartQuantity() {
    let totalQuantity = 0;
    for (var i = 0; i < this.cartProductsList.length; i++) {
      totalQuantity += this.cartProductsList[i].quantity;
    }
    return totalQuantity;
  },
  addItemToLocalCart(e, item) {
    item.quantity = item.quantity + 1;
    this.$store.dispatch('cart/updateLocalCart', item)
    .then(() => {
      this.local = true;
      this.$store.dispatch('cart/fetchCartProducts');
    });
  }, 
  handleAddToCartSuccess(payload) {
    this.$store.dispatch('cart/addCart', payload.item)
    .then(() => {
      this.$store.dispatch('cart/getCart');
    });
  },
  handleAddToCartFail(product) {
    alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
  },
  throttleAddToCart:  _.debounce(function(item, event) {
    this.addToCart(item)
  }, 150, {'leading': true, 'trailing': true}),
  addToCart: function(item) {
    if (!this.addToCartLoading) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})  
      } else {
        this.$store.dispatch('cart/incrementLocalCart', [item])      
      }
    }
  },
  goToProductDetail(product) {
    this.updateActiveProduct(product.ProductNum);
    this.$router.push({ 
      name: 'productDetails', 
      query: { productNum: product.ProductNum 
    }})
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch('cart/getCart')
      .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
         this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  beforeMount() {
    if (isUserAuthenticated()) {
      this.local = false;
      this.$store.dispatch('cart/getCart');
    } else {
      this.local = true;
      this.$store.dispatch('cart/fetchCartProducts');
    }
  },
  mounted() {
  },
  computed: mapState({
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    loggedIn: state => state.auth.loggedIn,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    mobile: state => state.cart.mobile,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    addToCartLoading: state => state.cart.addToCartLoading,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
  }),
  watch: {
    token: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== null || newVal !== undefined) {
        this.local = false;
         this.$store.dispatch('cart/getCart');
      } else {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      }
    },
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/cart.less";
</style>



// WEBPACK FOOTER //
// src/view/cart.vue